"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HaulerSendInvoiceEmailInput = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
exports.HaulerSendInvoiceEmailInput = typebox_1.Type.Object({
    email: typebox_1.Type.Union([typebox_1.Type.String(), typebox_1.Type.Array(typebox_1.Type.String())]),
    overrideMessage: typebox_1.Type.Optional(typebox_1.Type.String()),
    dumpTicket: typebox_1.Type.Optional(common_1.S3ItemReference),
    otherAttachments: typebox_1.Type.Optional(typebox_1.Type.Array(common_1.S3ItemReference)),
});
//# sourceMappingURL=send-email-input.js.map